import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { PogingSchema } from "./poging-schema";
import { bewaarPogingServer } from "./poging.server";


export const registreerBezoek = createServerFn({ method: "POST" })
  .inputValidator((d) => z.object({ sessieId: z.string().min(8).max(64), pad: z.string().max(300) }).parse(d))
  .handler(async ({ data }) => {
    if (data.pad.startsWith("/admin") || data.pad.startsWith("/dashboard") || data.pad.startsWith("/verzonden")) return { ok: true };
    const { supabaseAdmin } = await import("@/integrations/supabase/client.server");
    await supabaseAdmin.from("bezoeken").insert({ sessie_id: data.sessieId, pad: data.pad });
    return { ok: true };
  });

export const bewaarPoging = createServerFn({ method: "POST" })
  .inputValidator((d: unknown) => PogingSchema.parse(d))
  .handler(({ data }) => bewaarPogingServer(data));
